import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['legend', 'item'];
var baseStyle = {
  legend: {
    listStyle: 'none',
    p: 0,
    m: 0,
    display: 'flex'
  },
  item: {
    display: 'inline-flex',
    alignItems: 'center',
    symbol: {
      display: 'inline-block',
      width: '1.5rem',
      height: '1.5rem',
      borderRadius: '50%',
      bg: 'grey.400',
      mr: 6,
      flexShrink: 0
    },
    label: {
      fontSize: 'md',
      lineHeight: 'base',
      letterSpacing: 'tight',
      fontWeight: 'bold'
    }
  }
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});